import type { PhoneDetails } from '@bb/domain/dist/types';

export default (phone?: string | null | PhoneDetails[]) => {
  if (!phone) {
    return undefined;
  }

  const phoneStr =
    typeof phone === 'string'
      ? phone
      : phone.find(p => p.type === 'Primary')?.number;

  const formatted = phoneStr
    ?.trim()
    .match(/^(\+1|1)?\D*(\d{3})\D*(\d{3})\D*(\d{4})$/);

  if (formatted) {
    const countryCode = formatted[1] ? `${formatted[1]} ` : '';
    return `${countryCode}(${formatted[2]}) ${formatted[3]}-${formatted[4]}`;
  }

  return phoneStr;
};
